/**
 * /dashboard/bulk-imports/new — New bulk import wizard page (G7.5).
 *
 * 3-step flow lives inside BulkImportWizard; this page provides the
 * shell (header, back link, role gate). HR-admin only.
 *
 * Migration note (Phase 3f — 2026-06-01): port of
 * frontend/src/app/(dashboard)/dashboard/bulk-imports/new/page.tsx.
 * Swaps:
 *   - "use client" dropped
 *   - next/link Link → @tanstack/react-router Link
 */

import { createFileRoute, Link , useParams} from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { PageHeader } from "@/components/shared/page-header";
import { BulkImportRoleGate } from "@/components/bulk-imports/bulk-import-role-gate";
import { BulkImportWizard } from "@/components/bulk-imports/bulk-import-wizard";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/bulk-imports/new")({
  component: NewBulkImportRoute,
});

function NewBulkImportRoute() {
  const { tenantSlug } = useParams({ strict: false }) as { tenantSlug: string };
  return (
    <BulkImportRoleGate>
      <PageHeader
        title="New bulk import"
        description="Stage a CSV, review the row-by-row preview, then commit. Nothing is written until you hit Commit."
        actions={
          <Button asChild variant="outline" className="gap-1.5">
            <Link to="/app/$tenantSlug/bulk-imports" params={{ tenantSlug }}>
              <ArrowLeft aria-hidden className="h-4 w-4" />
              Back
            </Link>
          </Button>
        }
      />
      <BulkImportWizard />
    </BulkImportRoleGate>
  );
}
